// apiService.js
import { API_PASSWORD } from '../config';
import { getSubdomain, fetchWithAuth } from '../helpers';
import { getToken } from '../helpers';




  export const createCashier = async (cashierData) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/create/cashier?api_password=${API_PASSWORD}`;
  
    const res = await fetchWithAuth(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cashierData), // ⬅️ إرسال JSON
    });
  
    if (!res.ok) {
      const errText = await res.text();
      throw new Error(errText || "❌ فشل في إنشاء الكاشير.");
    }
  
    return res.json();
  };

  
  export const fetchCashiersByBranch = async (rootId) => {
    const subdomain = getSubdomain();
    const url = `https://${subdomain}.restocash.app/api/cashiers/data/${rootId}?api_password=${API_PASSWORD}`;
  
    const response = await fetchWithAuth(url, {
      method: "GET",
    });
  
    const text = await response.text();
    let data;
  
    try {
      data = JSON.parse(text);
    } catch (err) {
      console.error("🚫 الرد غير صالح (HTML بدلاً من JSON):", text);
      throw new Error("⚠️ لم يتم العثور على المسار أو الرد ليس بصيغة JSON.");
    }
  
    if (!response.ok) {
      throw new Error(data.message || "❌ فشل في جلب الكاشيرات");
    }
  
    return data.data || [];
  };


  export const updateCashier = async (cashierData) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/update/cashier`;
  
    const formData = new FormData();
    formData.append("id", cashierData.id);
    formData.append("name", cashierData.name);
    formData.append("printer_id", cashierData.printer_id);
    formData.append("root_id", cashierData.root_id);
  
    // لاحظ إننا ضفنا الباسورد في URL بدل ما تعتمد على fetchWithAuth
    const res = await fetch(`${apiUrl}?api_password=Project102$_`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
      body: formData,
    });
  
    if (!res.ok) {
      const errMsg = await res.text();
      throw new Error(errMsg || "❌ فشل في تعديل بيانات الكاشير.");
    }
  
    return res.json();
  };
  
  



export const toggleCashierStatus = async (id) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/change/cashier/status/${id}?api_password=${API_PASSWORD}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تغيير حالة الكاشير.");
  }

  return data;
};


// جلب بيانات الكاشير في تقفيل الفاتورة
export const fetchCashiers = async () => {
  const subdomain = window.location.hostname.split(".")[0];
  const rootId = localStorage.getItem("branch_id"); // ✅ استخدم root_id بدل branch_id

  if (!rootId) throw new Error("❌ لم يتم العثور على root_id في localStorage");

  const apiUrl = `https://${subdomain}.restocash.app/api/user/root/cashier/${rootId}?api_password=Project102$_`;

  const response = await fetch(apiUrl, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "❌ فشل في تحميل الكاشيرين");
  }

  return data.data; // ✅ تأكد أن هذه هي القائمة المطلوبة
};
